var cilTextDirectionRtl = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='131.313 355.313 108.687 332.687 25.373 416 108.687 499.313 131.313 476.687 86.627 432 496 432 496 400 86.627 400 131.313 355.313' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M352,368V72h56V40H220a100,100,0,0,0,0,200h36V368ZM288,72h32V336H288ZM220,208a68,68,0,0,1,0-136h36V208Z' class='ci-primary'/>"];

export { cilTextDirectionRtl };

